import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { LicenseManager } from "ag-grid-enterprise";
if (environment.production) {
  enableProdMode();
}
enableProdMode();
// if (environment.production) {
//   isDevMode();
// }
// LicenseManager.setLicenseKey("Invendis_Technologies_India__MultiApp_2Devs25_March_2020__MTU4NTA5NDQwMDAwMA==20890a2761628c031a58d63bcff6269a");
LicenseManager.setLicenseKey(
  "CompanyName=INVENDIS TECHNOLOGIES INDIA PRIVATE LIMITED,LicensedGroup=In House,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=0,AssetReference=AG-017624,ExpiryDate=4_August_2022_[v2]_MTY1OTU2NzYwMDAwMA==bc80a69b1d446334ec432860cfed2bb4"
);
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));


